import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import IndeterminateCheckBoxOutlinedIcon from '@mui/icons-material/IndeterminateCheckBoxOutlined';

import { IconButton, Tooltip } from '@mui/material';

import { useState, useEffect, useRef } from 'react';

const TextoColapsavel = ({ children, maxLines = 3, maxWidth = 200 }) => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [isExpandable, setIsExpandable] = useState(false);
    const contentRef = useRef(null);

    useEffect(() => {
        if (contentRef.current) {
            const computedStyle = window.getComputedStyle(contentRef.current);
            const contentHeight = contentRef.current.offsetHeight;
            const lineHeight = parseFloat(computedStyle.lineHeight);

            const totalLines = Math.ceil(contentHeight / lineHeight);
            setIsExpandable(totalLines > maxLines || isCollapsed);
            if (totalLines > maxLines) {
                setIsCollapsed(true);
            }
        }
    }, [children, maxLines]);

    const toggleCollapse = () => setIsCollapsed(!isCollapsed);

    return (
        <div style={{ display: "flex", alignItems: "flex-start", gap: "2px", maxWidth: maxWidth }}>
            {isExpandable ? (
                <Tooltip title={isCollapsed ? 'Ver mais filtros' : 'Ver menos'} disableFocusListener disableTouchListener >
                    <IconButton
                        size="small"
                        style={{ alignSelf: 'flex-start', padding: 0 }}
                        onClick={toggleCollapse}
                        aria-label={isCollapsed ? 'mostrar mais filtros' : 'mostrar menos'}
                    >
                        {isCollapsed ?
                            <AddBoxOutlinedIcon fontSize="inherit" sx={{ color: '#e89e13' }} /> :
                            <IndeterminateCheckBoxOutlinedIcon fontSize="inherit" sx={{ color: '#e89e13' }} />}
                    </IconButton>
                </Tooltip>
            ) : (<div style={{ width: '18px', height: '24px' }} />)
        }
            <div
                ref={contentRef}
                style={{
                    display: isCollapsed ? "-webkit-box" : "block",
                    WebkitLineClamp: isCollapsed ? maxLines : "none",
                    WebkitBoxOrient: "vertical",
                    overflow: isCollapsed ? "hidden" : "visible",
                    whiteSpace: "normal",
                    textOverflow: "clip",
                    maxWidth: maxWidth - 50
                }}
            >
                {children}
            </div>
        </div>
    );
};

export default TextoColapsavel;